export interface ILocation {
  lat: string;
  lon: string;
}

export class LocationHelper {
  static location: ILocation = { lat: '', lon: '' };
  static getLocationInfo(): Promise<ILocation> {
    return new Promise<ILocation>((resolve, reject) => {
      try {
          this.location.lat = '';
          this.location.lon = '';
          resolve(this.location);
      } catch (error) {
        this.location.lat = '';
        this.location.lon = '';
        reject(this.location);
      }
    });
  }
}
